module.exports = __webpack_public_path__ + "media/assets/images/start_page/startpage_graphic_wizard-cc1508e7bfe3c3e85a07197aea3d6676.svg";